try {
	window.$ = window.jQuery = require('jquery');
	require('jquery-mask-plugin');
} catch (e) { }

window.swal = require('sweetalert2');
window.creditCardType = require('credit-card-type');

import flatpickr from 'flatpickr';
import intlTelInput from 'intl-tel-input';

// Lodash stuff
import {
	mapValues,
	map,
	each,
	forEach,
	get,
	set,
	sortBy,
	filter,
	find,
	merge,
	value,
	uniqBy,
	size,
	isEmpty,
	maxBy
} from 'lodash-es';

window.mapValues = mapValues;
window.map = map;
window.each = each;
window.forEach = forEach;
window.get = get;
window.set = set;
window.sortBy = sortBy;
window.filter = filter;
window.find = find;
window.merge = merge;
window.value = value;
window.uniqBy = uniqBy;
window.size = size;
window.isEmpty = isEmpty;
window.maxBy = maxBy;

const chainableFunctions = {
	map,
	each,
	forEach,
	get,
	set,
	sortBy,
	filter,
	find,
	merge,
	value,
	uniqBy,
	size,
	isEmpty,
	maxBy
};

export const chain = (input) => {
	let value = input;
	const wrapper = {
		...mapValues(
			chainableFunctions,
			(f) => (...args) => {
				value = f(value, ...args);
				return wrapper;
			},
		),
		value: () => value,
	};
	return wrapper;
};
window.chain = chain;

jQuery(function ($) {
	$('[type="tel"]').each(function () {
		$(this).data('iti', intlTelInput($(this)[0], {
			autoHideDialCode: false,
			autoPlaceholder: false,
			initialCountry: "US",
			preferredCountries: ["US", "CA", "MX", "GB", "JP"],
			separateDialCode: true,
			utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.12/js/intlTelInput.min.js"
		}));
	});
}(jQuery));